<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M10.5 3h-3v4.5H3v3h4.5V15h3v-4.5H15v-3h-4.5V3z"/></svg>